import { type CardStatusEnum } from "@finway-group/shared/lib/models"
import { type ActionCreator, type Dispatch } from "redux"
import { invalidateCardQuery } from "~Shared/queries/card.queries"
import { CardService } from "~Shared/services/card.service"
import { type ThunkResult } from "~Shared/store"
import { CreditCardActionTypes, type FetchAllCardsAction, type SetShouldRefetchCardsAction } from "~Shared/store/actions/creditCard/creditCardTypes"
import { refetchCardRelatedTables } from "../tables/tableActions"

export const fetchAllCreditCards =
    (query = "", sortingCriteria = "", page = 1, limit = 20, append = false) =>
    async (dispatch: Dispatch) => {
        const { cards, totalPages, totalDocs } = await CardService.fetchCards(query, sortingCriteria, page, limit)

        const fetchAllCards: FetchAllCardsAction = {
            type: CreditCardActionTypes.FETCH_ALL_CARDS,
            cards,
            totalPages,
            totalDocs,
            append,
        }

        dispatch(fetchAllCards)

        // reset refetch flag
        setShouldRefetch(false)(dispatch)

        return cards
    }

export const setCreditCard = (card: any) => {
    if (card) {
        invalidateCardQuery(card._id)
    }
}

export const syncCreditCard: ActionCreator<ThunkResult<void>> = (card: any) => async (dispatch: Dispatch) => {
    // card can be either the card itself or the cardID
    if (!card._id) {
        card = await CardService.fetchCardById(card.toString())
    }

    invalidateCardQuery(card._id)
    dispatch(refetchCardRelatedTables())
}

export const updateCardStatus: ActionCreator<ThunkResult<void>> = (id: string, userId: string, status: CardStatusEnum) => async (dispatch: Dispatch) => {
    await CardService.updateCardStatus(id, userId, status)

    invalidateCardQuery(id)
    dispatch(refetchCardRelatedTables())
}

export const unblockCardPin: ActionCreator<ThunkResult<void>> = (id: string) => async (dispatch: Dispatch) => {
    const card = await CardService.unblockCardPin(id)
    invalidateCardQuery(card._id)
    dispatch(refetchCardRelatedTables())
}

export const topUpCard: ActionCreator<ThunkResult<void>> = (id: string) => async (dispatch: Dispatch) => {
    await CardService.topUpCard(id)
    invalidateCardQuery(id)
    dispatch(refetchCardRelatedTables())
}

export const emptyCard: ActionCreator<ThunkResult<void>> = (id: string) => async (dispatch: Dispatch) => {
    const card = await CardService.emptyCard(id)
    invalidateCardQuery(card._id)
    dispatch(refetchCardRelatedTables())
}

export const setShouldRefetch = (shouldRefetch: boolean) => async (dispatch: Dispatch) => {
    const setShouldRefetchAction: SetShouldRefetchCardsAction = {
        type: CreditCardActionTypes.SET_SHOULD_REFETCH_CARDS,
        shouldRefetch,
    }

    dispatch(setShouldRefetchAction)
}
